import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Dialog,
  IconButton,
  // Paper,
  Stack,
  Typography,
} from "@mui/material";
import { blue, green, grey, red } from "@mui/material/colors";
import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import ApexCharts from "apexcharts";
import { formatNumber } from "../modules";
import { notiError } from "../../utils/notiUltils";
//import Draggable from "react-draggable";
import bg2 from "../../images/bg2.png";
import { Badge, ConfigProvider, Table } from "antd";
import { ArrowDownward, ArrowUpward, Close } from "@mui/icons-material";
//import jsPDF from "jspdf";
//import "jspdf-autotable";

function WeeklyOverview({ api, setReloadData }) {
  const [dataSource, setDataSource] = useState({});
  const refChart = useRef(null);
  useEffect(() => {
    const options = {
      chart: {
        type: "bar",
        toolbar: {
          show: false,
        },
        height: "100%",
      },
      series: [
        {
          name: "Alarms",
          data: dataSource.data ?? [],
        },
      ],
      plotOptions: {
        bar: {
          borderRadius: 6,
          columnWidth: "32%",
          distributed: true,
          dataLabels: {
            position: "top",
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      grid: {
        show: true,
        borderColor: "#90A4AE88",
        strokeDashArray: 6,
        position: "back",
        xaxis: {
          lines: {
            show: false,
          },
        },
      },
      tooltip: {
        enabled: true,
        y: {
          title: {
            formatter: function (val) {
              return "<span style='color: #000; font-family:kanit;'>การแจ้งเตือน</span>";
            },
          },
          formatter: function (val) {
            return (
              "<span style='color: #000; font-family:kanit;'>" +
              formatNumber(val) +
              " ครั้ง</span>"
            );
          },
        },
        x: {
          formatter: function (val) {
            return (
              "<span style='color: #000;font-family:kanit;'>" + val + "</span>"
            );
          },
        },
      },

      xaxis: {
        categories: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },

      yaxis: {
        labels: {
          style: {
            colors: ["#90A4AE"],
          },
        },
      },
      colors: [
        function ({ value, seriesIndex, w }) {
          const category = w.config.xaxis.categories[seriesIndex];
          if (category === dayjs().format("ddd")) {
            return blue["400"];
          } else {
            return grey[600];
          }
        },
      ],
      legend: {
        show: false, // ตั้งค่านี้เพื่อปิดการแสดงผลของ legend
      },
      states: {
        active: {
          filter: {
            type: "none",
          },
        },
        hover: {
          filter: {
            type: "none", // ปิดการ highlight เมื่อเอาเมาส์ไปชี้
          },
        },
      },
    };
    const chart = new ApexCharts(document.querySelector("#chart"), options);
    chart.render();
    refChart.current = chart;
    return () => {
      chart.destroy();
    };
  }, [dataSource]);

  useEffect(() => {
    if (!api || !setReloadData) {
      return;
    }
    api
      .get("/dashboard3", localStorage.getItem("token"))
      .then((data) => {
        setDataSource(data);
        setReloadData(false);
      })
      .catch((error) => {
        console.error(error);
        notiError({ message: error, position: "center" });
      });
  }, [api, setReloadData]);

  return (
    <Card
      sx={{ height: "100%", p: 1, display: "flex", flexDirection: "column" }}
    >
      <CardHeader
        title={"ภาพรวมรายสัปดาห์"}
        titleTypographyProps={{ variant: "subtitle1", whiteSpace: "nowrap" }}
      />
      <CardContent
        sx={{ flexGrow: 1, pt: 0, display: "flex", flexDirection: "column" }}
      >
        <Box flexGrow={1} minHeight={206}>
          <div id="chart"></div>
        </Box>
        <Box>
          <Stack spacing={2} direction={"row"} alignItems={"center"}>
            <Typography variant="h5" whiteSpace={"nowrap"}>
              {dataSource.percentage ?? 0} %
            </Typography>
            <Typography color="text.secondary" variant="body1">
              ผลการแจ้งเตือน
              {(dataSource.percentage ?? 0) >= 0 ? "เพิ่มขึ้น" : "ลดลง"}{" "}
              {Math.abs(dataSource.percentage ?? 0)} % 😎
              เทียบกับวันเดียวกันเมื่อสัปดาห์ที่แล้ว
            </Typography>
          </Stack>
        </Box>
      </CardContent>
      <CardActions>
        <DraggableDialog api={api} />
      </CardActions>
    </Card>
  );
}

export default WeeklyOverview;

/*function PaperComponent(props) {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}*/
/*const monthMapping = {
  Jan: "ม.ค.",
  Feb: "ก.พ.",
  Mar: "มี.ค.",
  Apr: "เม.ย.",
  May: "พ.ค.",
  Jun: "มิ.ย.",
  Jul: "ก.ค.",
  Aug: "ส.ค.",
  Sep: "ก.ย.",
  Oct: "ต.ค.",
  Nov: "พ.ย.",
  Dec: "ธ.ค.",
};*/

function DraggableDialog({ api }) {
  const refChart = useRef(null);
  const [open, setOpen] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (!open) {
      return;
    }
    if (refChart.current) {
      refChart.current.destroy();
    }

    api
      .get("/weekSumary", localStorage.getItem("token"))
      .then((data) => {
        //data.dataSource.sort((a, b) => (a.gps_date > b.gps_date ? -1 : 1));
        /*const formattedDatesThai = data.categories.map((dateStr) => {
          const date = new Date(dateStr);
          const day = date.getDate().toString().padStart(2, "0");
          const month =
            monthMapping[date.toLocaleString("en-US", { month: "short" })];
          return `${day} ${month}`;
        });*/
        const formattedDatesThai = data.categories.map((dateStr) => {
          return dayjs(dateStr).format("ddd");
        });
        setDataSource(data.dataSource);
        setTimeout(() => {
          const options = {
            series: data.series,
            chart: {
              height: 400,
              type: "area",
              zoom: {
                enabled: false,
              },
              toolbar: {
                export: {
                  svg: {
                    filename: `area_chart_${dayjs().format(
                      "YYYY-MM-DD HH-mm-ss"
                    )}`,
                  },
                  png: {
                    filename: `area_chart_${dayjs().format(
                      "YYYY-MM-DD HH-mm-ss"
                    )}`,
                  },
                },
              },
            },
            colors: ["#00e396", "#b4a0ff"],
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: "smooth",
            },
            xaxis: {
              //type: "datetime",
              categories: formattedDatesThai,
            },
            grid: {
              show: true,
              borderColor: "#90A4AE88",
              strokeDashArray: 5,
            },
            tooltip: {
              x: {
                format: "dd-MM-yyyy",
              },
            },
            legend: {
              position: "bottom",
              show: true,
            },
          };
          const chart = new ApexCharts(
            document.querySelector("#chart_02"),
            options
          );
          chart.render();
          refChart.current = chart;
        }, 100);
      })
      .catch((error) => {
        console.error(error);
        notiError({ message: error, position: "center" });
      });
  }, [open, api]);

  /*const exportTableToPDF = () => {
    const doc = new jsPDF();

    const tableColumn = [
      "Date",
      "Last week",
      "Current week",
      "Change",
      "Percentage",
    ];
    const tableRows = [
      ...dataSource.map((a) => [
        dayjs(a.gps_date).format("ddd"),
        a.lastAmount,
        a.amount,
        a.amount - a.lastAmount,
        Math.abs(((a.amount - a.lastAmount) / a.lastAmount) * 100).toFixed(1),
      ]),
    ];

   
    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
    });

    doc.save("table_data.pdf");
  };*/

  return (
    <React.Fragment>
      <Button fullWidth variant="contained" onClick={handleClickOpen}>
        รายละเอียด
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        //PaperComponent={PaperComponent}
        //aria-labelledby="draggable-dialog-title"
        fullWidth
        maxWidth={"md"}
        scroll="body"
      >
        <Card
          sx={{
            backgroundImage: `url(${bg2})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundColor: "#b4a0ff",
            backgroundRepeat: "no-repeat",
            p: 5,
          }}
        >
          <CardHeader
            className="animate__animated animate__lightSpeedInRight"
            //id="draggable-dialog-title"
            title={"ภาพรวมการแจ้งเตือนรายสัปดาห์"}
            titleTypographyProps={{ variant: "h6", component: "h2" }}
            subheader={"แสดงรายการเปรียบเทียบข้อมูลการแจ้งเตือน"}
            subheaderTypographyProps={{ variant: "caption" }}
            action={
              <IconButton onClick={handleClose}>
                <Close />
              </IconButton>
            }
            //sx={{ cursor: "move" }}
          />
          <CardContent>
            <Badge.Ribbon text="กราฟรายวัน" placement="start">
              <Card
                elevation={24}
                className="animate__animated animate__backInUp"
                sx={{ pt: 1, pb: 2 }}
              >
                <CardContent>
                  <Box>
                    <div id="chart_02"></div>
                  </Box>
                  {/*  <button onClick={exportTableToPDF}>
                    Export Table to PDF
                  </button> */}
                  <TableData dataSource={dataSource} />
                </CardContent>
              </Card>
            </Badge.Ribbon>
          </CardContent>
        </Card>
      </Dialog>
    </React.Fragment>
  );
}

function TableData({ dataSource }) {
  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "kanit",
          colorBgContainer: "transparent",
        },
      }}
    >
      <Table
        dataSource={dataSource}
        //size="small"
        bordered
        pagination={false}
        columns={[
          {
            title: "ลำดับ",
            align: "center",
            render: (a, b, c) => (
              <Typography variant="body2" fontWeight={300}>
                {c + 1}
              </Typography>
            ),
          },

          {
            title: "วัน",
            //dataIndex: "gps_date",
            key: "day",
            render: (a) => (
              <Typography variant="body2" fontWeight={300}>
                {dayjs(a.gps_date).format("ddd")}
              </Typography>
            ),
          },
          {
            title: "ก่อนหน้า",
            align: "center",
            render: (a) => (
              <Typography
                variant="body2"
                color={green["A700"]}
                fontWeight={300}
              >
                {a.lastAmount}
              </Typography>
            ),
          },
          {
            title: "ล่าสุด",
            align: "center",
            render: (a) => (
              <Typography variant="body2" color="#775cd5" fontWeight={300}>
                {a.amount}{" "}
              </Typography>
            ),
          },

          {
            title: "เปลี่ยนแปลง",
            align: "center",
            render: (a) => (
              <Stack
                direction={"row"}
                color={a.amount - a.lastAmount >= 0 ? green["A700"] : red[900]}
                justifyContent={"center"}
                alignItems={"center"}
                spacing={0.5}
              >
                {a.amount - a.lastAmount > 0 && (
                  <ArrowUpward sx={{ fontSize: "13px" }} />
                )}
                {a.amount - a.lastAmount < 0 && (
                  <ArrowDownward sx={{ fontSize: "13px" }} />
                )}
                <Typography variant="body2" fontWeight={300}>
                  {Math.abs(a.amount - a.lastAmount)}
                </Typography>
              </Stack>
            ),
          },
          {
            title: "เปอร์เซ็นต์",
            align: "center",
            render: (a) => (
              <Typography
                variant="body2"
                fontWeight={300}
                color={
                  (((a.amount - a.lastAmount) / a.lastAmount) * 100).toFixed(
                    1
                  ) >= 0
                    ? green["A700"]
                    : red[900]
                }
              >
                {a.lastAmount === 0 && a.amount === 0
                  ? 0
                  : a.lastAmount === 0
                  ? 100
                  : Math.abs(
                      ((a.amount - a.lastAmount) / a.lastAmount) * 100
                    ).toFixed(1)} %
              </Typography>
            ),
          },
        ]}
      />
    </ConfigProvider>
  );
}
